import request from "../plugins/axios";

//获取日志列表
export function getLogList(params) {
    return request({
        url: '/updateLog/getUpdateLog',
        method: 'GET',
        params
    })
}